
import AuthAccess from '../features/auth/components/AuthAccess/AuthAccess'
import ConsumptionPage from '../pages/ConsumptionPage/ConsumptionPage'
import GrafanaPage from '../pages/GafanaPage/GrafanaPage'
import MainPage from '../pages/MainPage/MainPage'
import TestPage from '../pages/TestPage/TestPage'

const homeRoutes = [
    {
        path: "/",
        name: "Consommation",
        main: () => <ConsumptionPage headerFixed />
    },
    {
        path: "/grafana",
        name: "Grafana Page",
        main: () => <GrafanaPage  />

    }, 
    {
        path: "/test",
        name: "Test Page",
        main: () => <TestPage />
    },
    {
        name: "Home",
        path: "/main/*",
        main: () => <AuthAccess><MainPage /></AuthAccess>
    }
]


export default homeRoutes